var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarbageTruck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_523",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29235",
    "data-name": "Group 29235",
    transform: "translate(286 10673)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -286, -10673)",
    filter: "url(#Ellipse_523)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_523-2",
    "data-name": "Ellipse 523",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50375",
    "data-name": "Path 50375",
    d: "M315.395,174.134l3.99-14.913h5.795a.547.547,0,0,1,.438.219l1.656,2.209,1.821,6.8v4.127Z",
    transform: "translate(-559.889 -10806.063)",
    fill: "#6eaa2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50376",
    "data-name": "Path 50376",
    d: "M316.958,159.221l-1.563,14.913,3.99-1.563V159.221Z",
    transform: "translate(-559.889 -10806.063)",
    fill: "#58931f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50377",
    "data-name": "Path 50377",
    d: "M377.708,198.018h-2.8a.547.547,0,0,1-.407-.181l-.563-.626a2.11,2.11,0,0,0-1.569-.7h-3.823a.547.547,0,0,1-.547-.547v-4.2a.547.547,0,0,1,.547-.547h7.342L377.6,193.5a.547.547,0,0,1,.109.328Z",
    transform: "translate(-608.503 -10835.636)",
    fill: "#edf6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50378",
    "data-name": "Path 50378",
    d: "M361.4,285.467h-.543a.586.586,0,1,1,0-1.172h.543a.586.586,0,1,1,0,1.172Z",
    transform: "translate(-601.362 -10921.649)",
    fill: "#47840b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50379",
    "data-name": "Path 50379",
    d: "M22.364,111.534H38.255l.055,1.031.568.713V128.5l-8.5,1.563-2.427-2.909-10.976-1.414-2.489-3.936V117.6l6.559-4.338Z",
    transform: "translate(-281.809 -10761.993)",
    fill: "#6eaa2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50380",
    "data-name": "Path 50380",
    d: "M2.6,117.464l5.413-3.374a.547.547,0,0,0,.231-.3l.727-2.26H7.763L5.9,113.793a.547.547,0,0,1-.231.3L.258,117.464a.547.547,0,0,0-.258.464v3.195a.548.548,0,0,0,.07.268l2.357,4.2L3.571,126.6l1.2-1.011-2.357-4.2a.547.547,0,0,1-.07-.268v-3.195a.547.547,0,0,1,.258-.464Zm11.962,8.128,1.256,4.08,3.515-1.171-2.263-2.712a.547.547,0,0,0-.42-.2H14.564Z",
    transform: "translate(-268.419 -10761.992)",
    fill: "#58931f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50381",
    "data-name": "Path 50381",
    d: "M42.593,154.112l.794,1.414,2.772-9.411-.394-.75-1.106,1.685Z",
    transform: "translate(-307.781 -10793.258)",
    fill: "#58931f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50382",
    "data-name": "Path 50382",
    d: "M37.336,111.533H36.6a.547.547,0,0,0-.521.379l-.605,1.881a.548.548,0,0,1-.059.127l-.546,1.865,1.5-.935.946-3.21A.615.615,0,0,0,37.336,111.533ZM32,125.592l.492.8.756-.8.35-1.332-.794-1.414Z",
    transform: "translate(-297.992 -10761.992)",
    fill: "#47840b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50383",
    "data-name": "Path 50383",
    d: "M110.276,145.135h-2.757a.046.046,0,0,1-.04-.068L108.593,143l.1.268a.586.586,0,1,0,1.1-.4l-.542-1.5a.587.587,0,0,0-.7-.368l-1.618.412a.586.586,0,1,0,.289,1.136l.324-.083-1.1,2.037a1.218,1.218,0,0,0,1.072,1.8h2.757a.586.586,0,1,0,0-1.172Zm4.975-3.237a.586.586,0,1,0-1.015.586l1.458,2.525a.041.041,0,0,1,0,.045.04.04,0,0,1-.034.023h-2.371l.206-.244a.586.586,0,1,0-.9-.755l-1.024,1.216a.59.59,0,0,0,.03.793l1.163,1.193a.586.586,0,0,0,.839-.818l-.207-.213h2.288a1.218,1.218,0,0,0,1.02-1.827Zm-3.786-4.046,1.229,2-.281-.05a.586.586,0,0,0-.206,1.154l1.569.28a.588.588,0,0,0,.668-.423l.452-1.6a.586.586,0,1,0-1.128-.318l-.091.322-1.214-1.972a1.218,1.218,0,0,0-2.092.03l-1.4,2.423a.586.586,0,1,0,1.015.586l1.4-2.423a.041.041,0,0,1,.039-.023A.046.046,0,0,1,111.464,137.853Z",
    transform: "translate(-366.655 -10785.213)",
    fill: "#edf6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50384",
    "data-name": "Path 50384",
    d: "M254.926,112.081v1.2l-5.517,15.469a.586.586,0,0,1-.552.389.578.578,0,0,1-.2-.034.585.585,0,0,1-.355-.749l6-16.818h.076a.547.547,0,0,1,.547.547Z",
    transform: "translate(-497.857 -10761.993)",
    fill: "#58931f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50385",
    "data-name": "Path 50385",
    d: "M42.967,302.213H7.021l-1.852-.6-.108-1.28a2.132,2.132,0,0,1,.119-.728l4.268-2.73H19.24l2.427,2.909h21.3a.547.547,0,0,1,.547.547v1.333a.547.547,0,0,1-.547.547Z",
    transform: "translate(-273.095 -10933.276)",
    fill: "#edba48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50386",
    "data-name": "Path 50386",
    d: "M4.772,296.877H2.427l-2.3,2.756a.547.547,0,0,0-.127.35v1.682a.547.547,0,0,0,.547.547h1.8v-2.229a.547.547,0,0,1,.127-.351Z",
    transform: "translate(-268.419 -10933.276)",
    fill: "#e2a02b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_496",
    "data-name": "Ellipse 496",
    cx: 3.882,
    cy: 3.882,
    r: 3.882,
    transform: "translate(-240.242 -10636.399)",
    fill: "#465679"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_497",
    "data-name": "Ellipse 497",
    cx: 1.504,
    cy: 1.504,
    r: 1.504,
    transform: "translate(-237.864 -10634.021)",
    fill: "#39395f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_498",
    "data-name": "Ellipse 498",
    cx: 3.882,
    cy: 3.882,
    r: 3.882,
    transform: "translate(-263.805 -10636.306)",
    fill: "#465679"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_499",
    "data-name": "Ellipse 499",
    cx: 1.504,
    cy: 1.504,
    r: 1.504,
    transform: "translate(-261.427 -10633.928)",
    fill: "#39395f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarbageTruck);
export default __webpack_public_path__ + "static/media/garbageTruck.8434263b86fa89dc1e23274dcf0ba223.svg";
export { ForwardRef as ReactComponent };